export enum ControllerItemType {
  CHANNEL = 'Channel',
  THERMOCOUPLE = 'Thermocouple',
}